import {
  actionTypes as asyncTypes,
  isAsyncOperation,
  isAsyncComplete,
} from "async-ops";
import { GET_MY_EXTERNAL_AUDITS_STATUS } from "../services/get-my-external-audits-status";
import { cloneDeep, cloneDeepWith, isEqual } from "lodash";
import {
  isMdaeWidgetOptionChangeEvent,
  updateStateAfterWidgetOptionChange,
} from "../../../../../common_components/mdae-framework";
export const SET_MY_EA_AUDIT_BY_STATUS_DASHBOARD_PROPERTIES_DATA =
  "SET_MY_EA_AUDIT_BY_STATUS_DASHBOARD_PROPERTIES_DATA";
export const TOGGLE_MY_EA_AUDIT_BY_STATUS_DASHBOARD_PROPERTIES_POPUP =
  "TOGGLE_MY_EA_AUDIT_BY_STATUS_DASHBOARD_PROPERTIES_POPUP";
const initialState = {
  isLoading: false,
  myExternalAuditsStatus: [],
};

export default function(state = initialState, action) {
  let newState;
  switch (action.type) {
    case asyncTypes.OPERATION:
    case asyncTypes.COMPLETE:
    case asyncTypes.FAILURE:
      if (isAsyncOperation(GET_MY_EXTERNAL_AUDITS_STATUS)(action)) {
        return { ...state, myExternalAuditsStatus: [] };
      }
      if (isAsyncComplete(GET_MY_EXTERNAL_AUDITS_STATUS)(action)) {
        const response = action.response;
        return { ...state, myExternalAuditsStatus: response };
      }
      return state;
    case SET_MY_EA_AUDIT_BY_STATUS_DASHBOARD_PROPERTIES_DATA:
      newState = cloneDeep(state);
      if (isMdaeWidgetOptionChangeEvent(action.data)) {
        newState = updateStateAfterWidgetOptionChange(newState, action.data);
      } else {
        newState = {
          ...newState,
          myExternalAuditByStatusPropertiesData: action.data,
        };
      }
      return newState;
    case TOGGLE_MY_EA_AUDIT_BY_STATUS_DASHBOARD_PROPERTIES_POPUP:
      newState = cloneDeep(state);
      if (isMdaeWidgetOptionChangeEvent(action.data)) {
        newState = updateStateAfterWidgetOptionChange(newState, action.data);
      } else {
        newState = {
          ...newState,
          ...action.data,
          currentPropertyWidgetId: action.data.widgetId,
        };
      }
      return newState;
    default:
      return state;
  }
}
